import { ref } from 'vue'
import ApiService from '@/services/api.js'

export function useAbout() {
  // Reactive state
  const aboutFeatures = ref([])
  const missionVisionCards = ref([])

  // About features yükleme
  const loadAboutFeatures = async () => {
    try {
      const aboutFeaturesData = await ApiService.getAboutFeatures()
      if (aboutFeaturesData && aboutFeaturesData.length > 0) {
        aboutFeatures.value = aboutFeaturesData.map(feature => ({
          title_tr: feature.title_tr,
          title_en: feature.title_en,
          description_tr: feature.description_tr,
          description_en: feature.description_en,
          icon_url: feature.icon_url,
          icon_svg: feature.icon_svg
        }))
      } else {
        // Fallback about features
        aboutFeatures.value = [
          {
            title_tr: 'Uzman Ekip',
            title_en: 'Expert Team',
            description_tr: 'Alanında uzman mühendis ve teknisyenlerden oluşan güçlü ekibimiz.',
            description_en: 'Our strong team of expert engineers and technicians in their field.',
            icon_url: '',
            icon_svg: '<i class="fas fa-users"></i>'
          },
          {
            title_tr: 'Modern Teknoloji',
            title_en: 'Modern Technology',
            description_tr: 'En son teknoloji ürünleri ve sistemleri kullanıyoruz.',
            description_en: 'We use the latest technology products and systems.',
            icon_url: '',
            icon_svg: '<i class="fas fa-microchip"></i>'
          }
        ]
      }
    } catch (error) {
      console.error('About features yüklenemedi:', error)
    }
  }

  // Mission vision cards yükleme
  const loadMissionVisionCards = async () => {
    try {
      const missionVisionData = await ApiService.getMissionVisionCards()
      if (missionVisionData && missionVisionData.length > 0) {
        missionVisionCards.value = missionVisionData.map(card => ({
          title_tr: card.title_tr,
          title_en: card.title_en,
          description_tr: card.description_tr,
          description_en: card.description_en,
          background_image: card.background_image,
          icon_url: card.icon_url,
          icon_svg: card.icon_svg
        }))
      } else {
        // Fallback mission vision cards
        missionVisionCards.value = [
          {
            title_tr: 'Misyonumuz',
            title_en: 'Our Mission',
            description_tr: 'Temiz enerjinin geleceğini inşa etmek ve sürdürülebilir enerji çözümleri sunmak.',
            description_en: 'Building the future of clean energy and providing sustainable energy solutions.',
            background_image: 'https://images.unsplash.com/photo-1497440001374-f26997328c1b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80',
            icon_url: '',
            icon_svg: ''
          },
          {
            title_tr: 'Vizyonumuz',
            title_en: 'Our Vision',
            description_tr: 'Sürdürülebilir bir dünya için yenilenebilir enerji kaynaklarının öncüsü olmak.',
            description_en: 'To be a pioneer in renewable energy sources for a sustainable world.',
            background_image: 'https://images.unsplash.com/photo-1466611653911-95081537e5b7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80',
            icon_url: '',
            icon_svg: ''
          }
        ]
      }
    } catch (error) {
      console.error('Mission vision cards yüklenemedi:', error)
    }
  }

  // Initialize
  loadAboutFeatures()
  loadMissionVisionCards()

  return {
    aboutFeatures,
    missionVisionCards,
    loadAboutFeatures,
    loadMissionVisionCards
  }
}